export default __webpack_public_path__ + "static/media/meat.94ca10ab.png";